@let bullet = this.bullet();
@if (bullet) {
  <rma-icon [glyph]="bullet" [class]="bullet" />
}
<ng-content />
